module.exports = __webpack_public_path__ + "img/公众号二维码1.20e341d1.png";